export default __webpack_public_path__ + "static/flowerSoeun-f124fefc54c5829269e4dae64f16dbdb.png";